import { injectable } from "inversify";
import AuthRepository from "../../repositories/AuthRepository";
import ErrorEntity from "../../entities/ErrorEntity";
import UserEntity from "../../entities/UserEntity";
import { Either, isRight } from "fp-ts/lib/Either";
import UserProvider from "../../providers/user/UserProvider";

interface _Props {
    userProvider: UserProvider;
    authRepository: AuthRepository;
}

@injectable()
export default class GetCurrentUserUseCase {
    private userProvider: UserProvider;
    private authRepository: AuthRepository;
    constructor(props: _Props) {
        this.userProvider = props.userProvider;
        this.authRepository = props.authRepository;
    }
    public call = async (): Promise<UserEntity | null> => {
        const currentUser = await this.authRepository.getCurrentUser();
        this.userProvider.Actions.setUser(currentUser);
        return currentUser;
    }
}

export const GetCurrentUserUseCaseName = "GetCurrentUserUseCase";